import React from "react";

// Importing required Bootstrap styles and components
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Twitter } from "react-bootstrap-icons";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      author: "",
      quoteText: "",
      apiLink: "https://api.quotable.io/random",
    };

    this.grabQuote = this.grabQuote.bind(this);
  }

  grabQuote = async () => {
    const res = await fetch(this.state.apiLink);
    const data = await res
      .json()
      .then((data) =>
        this.setState({ author: data.author, quoteText: data.content })
      );
  };

  componentDidMount() {
    this.grabQuote();
  }

  render() {
    return (
      <div>
        <Container id="quote-box">
          <Card
            className="text-center shadow-lg p-3 mb-5 bg-white rounded"
            style={{ maxWidth: "36rem", maxHeight: "auto", minHeight: "10rem" }}
          >
            <Card.Body>
              <Card.Text className="lead" id="text">
                {this.state.quoteText}
              </Card.Text>
              <Card.Text id="author">{this.state.author}</Card.Text>
              <Row>
                <Col>
                  <a
                    id="tweet-quote"
                    href="twitter.com/intent/tweet"
                    target="_blank"
                  >
                    <Twitter style={{ fontSize: "2rem" }} />
                  </a>
                </Col>
                <Col md={{ span: 4, offset: 4 }}>
                  <Button
                    id="new-quote"
                    variant="outline-primary"
                    className="center-block"
                    onClick={this.grabQuote}
                  >
                    New Quote
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </div>
    );
  }
}
export default App;
